import React, { useState, useEffect } from "react";
import Background from "../../assets/background_2.png";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

import Card from "./Card";
import BoardOfCouncil from "./board_of_council";
import BoardOfManagment from "./board_of_managment";
import BoardOfStudies from "./board_of_studies";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchVisionData,
  fetchLeadershipData,
  fetchHistoryData,
} from "../../redux/slicer/aboutUsSlicer";

import parse from "html-react-parser";
import Preloader from "../../assets/sab.jpeg";
import AboutUsImg from "../../assets/Banners/AboutUs.jpg";
import OurMissionImg from "../../assets/Our Mission.JPG";
import OurVisionImg from "../../assets/Our Vision2.JPG";

function AboutUs() {
  const dispatch = useDispatch();

  const {
    data: visionData,
    loading: VisionLoading,
    error: VisionError,
  } = useSelector((state) => state.aboutUs.vision);

  const {
    data: leadershipData,
    loading: leadershipLoading,
    error: leadershipError,
  } = useSelector((state) => state.aboutUs.leadership);

  const {
    data: historyData,
    loading: historyLoading,
    error: historyError,
  } = useSelector((state) => state.aboutUs.history);

  useEffect(() => {
    dispatch(fetchVisionData());
    dispatch(fetchLeadershipData());
    dispatch(fetchHistoryData());
  }, [dispatch]);

  // State for Card component expansion
  const [expandedCard, setExpandedCard] = useState(null);

  // State for leadership messages expansion
  const [expanded, setExpanded] = useState({});

  // Toggle function for Card components
  const toggleCard = (cardId) => {
    setExpandedCard((prev) => (prev === cardId ? null : cardId));
  };

  // Toggle function for leadership messages
  const toggleReadMore = (id) => {
    setExpanded((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getTruncatedMessage = (message, isExpanded) => {
    if (typeof message !== "string") return "Message unavailable";
    const words = message.split(" ");
    if (isExpanded || words.length <= 120) {
      return message;
    }
    return words.slice(0, 120).join(" ") + "...";
  };

  // Helper function to safely parse HTML strings
  const safeParse = (value, fallback = "N/A") => {
    if (typeof value === "string" && value.trim()) {
      try {
        return parse(value);
      } catch (error) {
        console.error(`Failed to parse HTML: ${value}`, error);
        return fallback;
      }
    }
    console.warn(`Invalid value for parsing: ${value}`);
    return fallback;
  };

  // Debug leadershipData to identify problematic values
  useEffect(() => {
    if (leadershipData) {
      leadershipData.forEach((item, index) => {
        if (!item.id) {
          console.warn(`Item ${index} is missing id:`, item);
        }
        if (typeof item.message_type !== "string") {
          console.warn(`Item ${index} has invalid message_type:`, item.message_type);
        }
        if (typeof item.designation !== "string") {
          console.warn(`Item ${index} has invalid designation:`, item.designation);
        }
        if (typeof item.name !== "string") {
          console.warn(`Item ${index} has invalid name:`, item.name);
        }
        if (typeof item.message !== "string") {
          console.warn(`Item ${index} has invalid message:`, item.message);
        }
      });
    }
  }, [leadershipData]);

  if (VisionLoading || leadershipLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (VisionError || leadershipError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-lg font-bold text-red-600">
          Error: {VisionError || leadershipError}
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* Header Section */}
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full h-[200px] sm:h-[300px] lg:h-[400px]">
          <img
            src={AboutUsImg}
            alt="carousel-slide"
            className="object-cover object-center w-full h-full"
          />
          <div className="absolute px-4 text-center text-white transform -translate-x-1/2 top-1/3 left-1/2">
            <h2 className="text-3xl font-bold sm:text-4xl lg:text-6xl font-titillium">
              About Us
            </h2>
            <p className="mt-4 text-sm sm:text-base lg:text-lg">

            </p>
          </div>
        </div>
      </div>

      <div className="py-10">
        <div className="py-6 mt-5" id="history">
          <p className="text-5xl text-primary-color font-titillium">
            Our History
          </p>
        </div>
        <div className="relative w-full">
          <div className="relative w-full ">
            <div className="max-w-4xl p-6 m-4 mx-auto bg-white rounded-lg shadow-md">
              {historyData?.history ? (
                <div className="text-gray-700 font-inter">
                  {safeParse(historyData?.history, "No history available")}
                </div>
              ) : (
                <p>No history data available.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Vision & Mission Section */}
      <div className="py-10">
        <div className="py-6 mt-5" id="mission">
          <p className="text-5xl text-primary-color font-titillium">
            Vision & Mission
          </p>
        </div>

        {/*  Desktop and Tablet Specific Cards  */}
        <div className="relative w-full hidden sm:grid md:h-[600px] content-center">
            <div className="relative w-full h-[280px]">
                <img
                    src={Background}
                    alt="Background"
                    className="object-cover w-full h-full"
                />
            </div>

            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 grid grid-cols-2 gap-4 px-5 max-w-full w-[900px] z-5 items-start">
                <Card
                    imageSrc={OurVisionImg}
                    imageSrc2="https://hips.hearstapps.com/hmg-prod/images/graduating-class-royalty-free-image-1713814886.jpg?crop=1xw:0.84415xh;center,top&resize=1200:*"
                    title={<span className="font-titillium">Our Vision</span>}
                    description={<span className="font-inter">{visionData?.vision}</span>}
                    isExpanded={expandedCard === "vision"}
                    toggleCard={() => toggleCard("vision")}
                />
                <Card
                    imageSrc={OurMissionImg}
                    imageSrc2="https://hips.hearstapps.com/hmg-prod/images/graduating-class-royalty-free-image-1713814886.jpg?crop=1xw:0.84415xh;center,top&resize=1200:*"
                    title={<span className="font-titillium">Our Mission</span>}
                    description={<span className="font-inter">{visionData?.mission}</span>}
                    isExpanded={expandedCard === "mission"}
                    toggleCard={() => toggleCard("mission")}
                />
            </div>
        </div>

        {/*  Mobile Specific Cards - with reduced gap  */}
        <div className="grid grid-cols-1 px-4 py-6 sm:hidden gap-2"> {/* Reduced gap here */}
            <Card
                imageSrc={OurVisionImg}
                imageSrc2="https://hips.hearstapps.com/hmg-prod/images/graduating-class-royalty-free-image-1713814886.jpg?crop=1xw:0.84415xh;center,top&resize=1200:*"
                title={<span className="font-titillium">Our Vision</span>}
                description={<span className="font-inter">{visionData?.vision}</span>}
                isExpanded={expandedCard === "vision"}
                toggleCard={() => toggleCard("vision")}
            />
            <Card
                imageSrc={OurMissionImg}
                imageSrc2="https://hips.hearstapps.com/hmg-prod/images/graduating-class-royalty-free-image-1713814886.jpg?crop=1xw:0.84415xh;center,top&resize=1200:*"
                title={<span className="font-titillium">Our Mission</span>}
                description={<span className="font-inter">{visionData?.mission}</span>}
                isExpanded={expandedCard === "mission"}
                toggleCard={() => toggleCard("mission")}
            />
        </div>
    </div>

      {/* Leadership Messages Section */}
      <section id="leadership">
        <div className="">
          <div className="">
            <p className="text-2xl font-semibold text-center sm:text-3xl lg:text-4xl text-primary-color font-titillium">
              Leadership Messages
            </p>
            <div className="relative w-64 h-0.5 bg-primary-color mt-6 mx-auto">
              <div className="absolute transform -translate-y-1/2 -left-2 top-1/2">
                <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-primary-color"></div>
              </div>
              <div className="absolute transform -translate-y-1/2 -right-2 top-1/2">
                <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-primary-color"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="px-4 mt-6 sm:px-6 md:px-0">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-6">
          <div className="hidden md:block md:col-span-1"></div>
          <div className="grid w-full gap-8 mx-auto md:col-span-10 sm:w-11/12">
            {leadershipData?.map((item, index) => {
              const isExpanded = expanded[item.id];

              return (
                <div
                  key={item.id}
                  className={`rounded-lg flex flex-col lg:flex-row items-center lg:items-start justify-between p-6 gap-6 ${
                    index % 2 === 0 ? "bg-primary-color" : "bg-[#3F3F3F]"
                  }`}
                >
                  {index % 2 === 0 ? (
                    <>
                      {/* Left Side (Image) */}
                      <div className="w-full sm:w-1/2 md:w-3/4 lg:w-1/3">
                        <img
                          src={item.image_url}
                          alt={item.name || "Leadership"}
                          className="object-cover w-full md:h-[50vh] h-[48vh] sm:h-96 lg:h-[32vh] xl:h-[60vh] rounded-lg shadow-lg"
                        />
                      </div>
                      {/* Right Side (Text) */}
                      <div className="w-full pr-4 text-white lg:w-2/3">
                        <h2 className="px-2 mb-4 text-xl font-bold text-justify lg:px-8 lg:text-2xl font-inter">
                          {safeParse(item.message_type, "Message Type Unavailable")}
                          <div className="flex items-start justify-start gap-2">
                            <div className="h-2 w-10 rounded-full bg-[#3F3F3F]"></div>
                            <div className="h-2 w-2 rounded-full bg-[#3F3F3F]"></div>
                          </div>
                        </h2>
                       
                        <h2 className="px-8 font-bold text-left font-inter">
                          {safeParse(item.name, "Name Unavailable")}
                        </h2>
                        <p className="px-2 mt-5 text-justify lg:px-8 font-inter">
                          {safeParse(getTruncatedMessage(item.message, isExpanded), "Message Unavailable")}
                        </p>
                        {item.message && item.message.split(" ").length > 120 && (
                          <button
                            onClick={() => toggleReadMore(item.id)}
                            className="px-2 mt-2 text-sm font-bold text-white underline lg:px-8"
                          >
                            {isExpanded ? "Read Less" : "Read More"}
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Left Side (Text) */}
                      <div className="w-full pr-4 text-white lg:w-2/3">
                        <h2 className="px-2 mb-4 text-xl font-bold text-justify lg:px-8 lg:text-2xl font-inter">
                          {safeParse(item.message_type, "Message Type Unavailable")}
                          <div className="flex items-start justify-start gap-2">
                            <div className="w-10 h-2 rounded-full bg-primary-color"></div>
                            <div className="w-2 h-2 rounded-full bg-primary-color"></div>
                          </div>
                        </h2>
                        <h2 className="px-8 font-bold text-left font-inter">
                          {safeParse(item.name, "Name Unavailable")}
                        </h2>
                        <p className="px-2 mt-5 text-justify lg:px-8 font-inter">
                          {safeParse(getTruncatedMessage(item.message, isExpanded), "Message Unavailable")}
                        </p>
                        {item.message && item.message.split(" ").length > 120 && (
                          <button
                            onClick={() => toggleReadMore(item.id)}
                            className="px-2 mt-2 text-sm font-bold text-white underline lg:px-8"
                          >
                            {isExpanded ? "Read Less" : "Read More"}
                          </button>
                        )}
                      </div>
                      {/* Right Side (Image) */}
                      <div className="w-full sm:w-1/2 md:w-3/4 lg:w-1/3">
                        <img
                          src={item.image_url}
                          alt={item.name || "Leadership"}
                          className="object-cover w-full h-[45vh] md:h-[50vh] sm:h-96 lg:h-[32vh] xl:h-[60vh] rounded-lg shadow-lg"
                        />
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
          <div className="hidden md:block md:col-span-1"></div>
        </div>
      </div>

      {/* Boards Section */}
      <div className="grid grid-cols-1 py-8 lg:grid-cols-12">
        <div className="lg:col-span-2"></div>
        <div className="lg:col-span-8">
          <div id="council">
            <h2 className="py-6 font-sans text-2xl sm:text-3xl lg:text-4xl text-primary-color font-titillium">
              Council
            </h2>
            <div className="px-10 py-6">
              <BoardOfCouncil />
            </div>
          </div>
          <div id="managment">
            <h2 className="py-6 font-sans text-2xl sm:text-3xl lg:text-4xl text-primary-color font-titillium">
              Board Of Management
            </h2>
            <div className="px-10 py-6">
              <BoardOfManagment />
            </div>
          </div>
          <div id="studies">
            <h2 className="py-6 font-sans text-2xl sm:text-3xl lg:text-4xl text-primary-color font-titillium">
              Board Of Studies
            </h2>
            <div className="px-10 py-6">
              <BoardOfStudies />
            </div>
          </div>
        </div>
        <div className="lg:col-span-2"></div>
      </div>
    </div>
  );
}

export default AboutUs;